import { AppError } from '@/shared/utils/error-handling';

export const PAYWALL_ERROR_CODES: AppError[] = [
  'SUBPROJECT_QUOTA_EXCEEDED',
  'SEATS_QUOTA_EXCEEDED',
  'DERIVATIVE_KPI_QUOTA_EXCEEDED',
  'STANDARD_KPI_QUOTA_EXCEEDED',
  'STORAGE_LIMIT_EXCEEDED',
  'ORGANIZATION_SUBSCRIPTION_REQUIRED',
];

export function isPaywallError(error: AppError): boolean {
  return PAYWALL_ERROR_CODES.includes(error);
}

export function getPaywallContext(
  errorCode: AppError,
): 'project' | 'organization' | 'addon' {
  switch (errorCode) {
    case 'SUBPROJECT_QUOTA_EXCEEDED':
    case 'SEATS_QUOTA_EXCEEDED':
    case 'STANDARD_KPI_QUOTA_EXCEEDED':
      return 'project';
    case 'AI_FEATURE_NOT_AVAILABLE':
    case 'STORAGE_LIMIT_EXCEEDED':
    case 'ORGANIZATION_SUBSCRIPTION_REQUIRED':
      return 'organization';
    case 'DERIVATIVE_KPI_QUOTA_EXCEEDED':
      return 'addon';
  }

  return 'project';
}
